/*
Copyright (C) 2017  Cloudbase Solutions SRL
This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.
This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.
You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <http://www.gnu.org/licenses/>.
*/

import { css } from "styled-components";

// Montserrat, the Tech9IQ brand face (SIL Open Font Licence, see OFL-Montserrat.txt).
// The brand uses 400/500/600/700 only.
import MontserratRegular from "./Montserrat-Regular.ttf";
import MontserratMedium from "./Montserrat-Medium.ttf";
import MontserratSemiBold from "./Montserrat-SemiBold.ttf";
import MontserratBold from "./Montserrat-Bold.ttf";

const face = (src: string, weight: number) => css`
  @font-face {
    font-family: "Montserrat";
    src: url("${src}") format("truetype");
    font-weight: ${weight};
    font-style: normal;
    font-display: swap;
  }
`;

const Fonts = css`
  ${face(MontserratRegular, 400)}
  ${face(MontserratMedium, 500)}
  ${face(MontserratSemiBold, 600)}
  ${face(MontserratBold, 700)}
`;

export default Fonts;
